import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HeaderComponent } from "@components/header/header.component";
import { InputComponent } from "@components/input/input.component";
import { BusyService } from "~app/common/components/busy/busy.service";
import { CommandService } from "~app/common/services/cqs/command.service";
import { SysadmMoveAvtalComponent } from "./sysadm-move-avtal/sysadm-move-avtal.component";

@Component({
    selector: "rask-sysadm-virkeskop",
    templateUrl: "./sysadm-virkeskop.component.html",
    styleUrls: ["./sysadm-virkeskop.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        SysadmMoveAvtalComponent,
        BlockComponent,
        FormsModule,
        ButtonComponent,
        InputComponent
    ]
})
export class SysadmVirkeskopComponent {
    dokumentStatus: string;
    dokumentnyckel: string;

    private readonly busyService = inject(BusyService);
    private readonly commandService = inject(CommandService);

    skickaOmDokument() {
        const commandService = this.commandService.createInstance();
        commandService.addTransactionCommand({
            $type: "SkickaOmImportDokumentCommand",
            dokumentNyckel: this.dokumentnyckel,
            dokumentStatus: this.dokumentStatus
        });
        const obs = commandService.pushCommandQueueTransaction();
        this.busyService.addWork(obs)
            .subscribe(result => {
                // eslint-disable-next-line no-console
                console.log("Skickat");
            });
    }
}
